import { Divider, Input } from 'antd';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { PageHeader } from '../theme/theme';

const SettingsItemStyle = styled(Link)`
	padding: 20px;
	border-bottom: 1px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	transition: background-color 400ms ease;

	& .desc {
		width: 75%;
		font-size: 15px;
		color: #969696;
		margin-top: 10px;
	}

	& .icon {
		width: 50px;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-start;
		margin-right: 10px;
	}

	&:hover {
		background-color: #fafafa;
	}
`;

const UserSettings = () => {
	const { id } = useParams();

	const items = [
		{
			title: 'User Info Settings',
			desc: 'This is where the super admin can update user information',
			link: `/user-settings/${id}/info`,
			icon: 'manage_accounts',
		},
		{
			title: 'User general settings',
			desc: 'This is where the admin can make necessary changes',
			link: `/user-settings/${id}/general`,
			icon: 'manage_accounts',
		},
		{
			title: 'User Transaction settings',
			desc: 'Here, admin can carry out all savings settings for a user',
			link: `/user-settings/${id}/savings`,
			icon: 'manage_accounts',
		},
	];

	return (
		<section>
			<PageHeader>Users Settings</PageHeader>

			<Input.Search placeholder="Search Users Settings" />

			<Divider />

			<p>Frequently visited</p>

			<Divider />

			{items
				.sort((prev, next) => prev.title.localeCompare(next.title))
				.map((item) => (
					<SettingsItemStyle key={item.title} to={item.link}>
						<div style={{ display: 'flex' }}>
							<div className="icon">
								<span className="material-icons">{item.icon}</span>
							</div>
							<div>
								<p>
									<strong>{item.title}</strong>
								</p>
								<p className="desc">{item.desc}</p>
							</div>
						</div>
						<div className="arrow">
							<span className="material-icons">keyboard_arrow_right</span>
						</div>
					</SettingsItemStyle>
				))}
		</section>
	);
};

export default UserSettings;
